import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// Dev-only surface. In a production build `import.meta.env.DEV` is false, so the
// guard redirects out and every dev-gated child component below collapses to
// `() => null`, so the prototype kit and screens are dropped from the bundle.
function PrototypeLayout() {
	return <Outlet />;
}

export const Route = createFileRoute('/prototype')({
	beforeLoad: () => {
		if (!import.meta.env.DEV) throw redirect({ to: '/' });
	},
	component: PrototypeLayout,
});
